export const clearQueryParam = (param: string) => {
	const searchParams = new URLSearchParams(window.location.search);
	searchParams.delete(param);
	const newUrl = `${window.location.pathname}${searchParams.toString().length ? '?' : ''}${searchParams.toString()}`;
	window.history.replaceState(null, '', newUrl);
};

export const getQueryParam = (param: string) => {
	const searchParams = new URLSearchParams(window.location.search);
	return searchParams.get(param);
};
